export default "__VITE_PUBLIC_ASSET__62c063b7__"